import PropTypes from 'prop-types';
import React, { Component } from 'react';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import { sendAnalyticsEvent } from '../../../utils/analytics';
import padPrice from '../../../utils/padPrice';
import { link_target, link_rel } from '../../../utils/external_links';
import Lazy from '../../common/lazy';
import {get, isFinite} from 'lodash';

const withTranslatedSeparator = children =>
  <RosettaFormattedMessage parentFilename={__filename}
    id="separator"
    description="Separator for product attributes within product description"
    defaultMessage=","
  >
    {children}
  </RosettaFormattedMessage>;

const LAZY_LOAD_CUSHION_PX = 0;

export default class ProductDescription extends Component {
  handleClick = () => sendAnalyticsEvent(
    'Shopping',
    'Click',
    this.props.short_title
  );

  priceWithSeparator() {
    const { price, special_price, currency } = this.props;
    if (isFinite(special_price)) {
      return (
        <span>
          <s>{padPrice(currency, price)}</s>
          {withTranslatedSeparator(
            (separator) => (
              <span>{` ${padPrice(currency, special_price) + separator} `}</span>
            )
          )}
        </span>
      );
    }
    return (
      withTranslatedSeparator(
        (separator) => (
          <span>{` ${padPrice(currency, price) + separator} `}</span>
        )
      )
    );
  }

  render() {
    const {
      brand_name, short_title, retailer_name, external_full_path, sponsor_info
    } = this.props;

    const productUrl = (sponsor_info && sponsor_info.click_tracker_url ? sponsor_info.click_tracker_url : external_full_path);

    const impressionTracker = get(sponsor_info, 'impression_tracker_url');

    let impressionTrackerNode;
    if (impressionTracker) {
      impressionTrackerNode = (
        <Lazy cushion={LAZY_LOAD_CUSHION_PX}>
          <img src={impressionTracker} className="impression-tracker no-content" />
        </Lazy>
      );
    }

    return (
      <span>
        <b dangerouslySetInnerHTML={{ __html: `${brand_name} ` }} />

        {withTranslatedSeparator(
          (separator) => (
            <span dangerouslySetInnerHTML={{
              __html: `${short_title + separator} `
            }}
            />
          )
        )}

        {this.priceWithSeparator()}

        <RosettaFormattedMessage parentFilename={__filename}
          id="available_at"
          description="Text preceding the retailer on desktop slideshow product descriptions"
          defaultMessage="available at"
        >
          {
            (available_at) => (
              <span dangerouslySetInnerHTML={{ __html: `${available_at} ` }} />
            )
          }
        </RosettaFormattedMessage>

        <a href={productUrl}
          onClick={this.handleClick}
          target={link_target(productUrl)}
          rel={link_rel(productUrl, 'nofollow sponsored')}
          dangerouslySetInnerHTML={{ __html: retailer_name }}
        />

        {impressionTrackerNode}
      </span>
    );
  }
}

ProductDescription.propTypes = {
  brand_name: PropTypes.string.isRequired,
  retailer_name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  special_price: PropTypes.number,
  short_title: PropTypes.string.isRequired,
  external_full_path: PropTypes.string.isRequired,
  currency: PropTypes.string,
  sponsor_info: PropTypes.shape({
    click_tracker_url: PropTypes.string,
    impression_tracker_url: PropTypes.string
  })
};
